import React from 'react'
import MediaWithShimmer from './MediaWithShimmer'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import { useNavigate } from 'react-router-dom'

import video1 from '../img/Видео WhatsApp 2025-11-17 в 11.33.40_75502fa1.mp4'
import whiteVideo from '../imgs/white.mp4'
import white6 from '../imgs/white6.jpg'
import white11 from '../imgs/white11.jpg'
import white12 from '../imgs/white12.jpg'
import white8 from '../imgs/white8.jpg'
import white16 from '../imgs/white16.jpg'
import white17 from '../imgs/white17.jpg'
import white18 from '../imgs/white18.jpg'
import white19 from '../imgs/white19.jpg'
import white20 from '../imgs/white20.jpg'
import white21 from '../imgs/white21.jpg'

const WhiteCoutureCollection = () => {
  const { language } = useLanguage()
  const t = translations.whiteCouture
  const navigate = useNavigate()
  const images = [
    white8,
    white6,
    white11,
    white12,
    white16,
    white17,
    white18,
    white19,
    white20,
    white21
  ]

  return (
    <section
      id="white-couture"
      className="bg-white cursor-pointer"
      onClick={() => navigate('/shop')}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 md:py-10 pt-0">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {/* Первые 4 фото */}
          {images.slice(0, 4).map((src, index) => (
            <MediaWithShimmer
              key={`white-top-${index}`}
              src={src}
              alt={`White Collection ${index + 1}`}
              wrapperClassName={
                index >= 8
                  ? 'h-[620px] md:h-[580px]'
                  : 'h-[520px] md:h-[580px]'
              }
              className="w-full object-cover rounded-xl shadow-md"
            />
          ))}

          {/* Видео White Suits */}
          <MediaWithShimmer
            type="video"
            src={whiteVideo}
            autoPlay
            loop
            muted
            playsInline
            wrapperClassName="w-full rounded-3xl overflow-hidden"
            className="w-full h-[720px] md:h-[580px] object-cover"
          />

          {/* Оставшиеся фото */}
          {images.slice(4).map((src, idx) => {
            const index = 4 + idx
            return (
              <MediaWithShimmer
                key={`white-bottom-${index}`}
                src={src}
                alt={`White Collection ${index + 1}`}
                wrapperClassName={
                  // Для white16 (index === 4) и последних кадров используем большую высоту,
                  // чтобы изображение не казалось обрезанным.
                  index === 4 || index >= 8
                    ? 'h-[620px] md:h-[580px]'
                    : 'h-[520px] md:h-[580px]'
                }
                className="w-full object-cover rounded-xl shadow-md"
              />
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default WhiteCoutureCollection
